import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'next/link'

import RawHTML from '../../common/raw-html'
import Card from './index'
import Button from '../button'

import Typography from '../typography'
import { useBreakpoint } from '../../../hooks/breakpoint'

import Image from '../image'
import Icon from '../icon'
import ArrowRight from '../icon/arrow-right.svg'

import styles from '../../../styles/bantrab/components/card.module.scss'

const CardBigDefault = ({ title, text, slug, date, author, time, url, image, category, ...attrs }) => {
  const breakpoint = useBreakpoint()
  let readingTime = 0

  if (time) {
    readingTime = time.split(':').map(item => parseInt(item))
    readingTime = readingTime[0] * 60 + readingTime[1] + readingTime[2] / 60
    readingTime = Math.round(readingTime)
  }

  attrs.className = classNames(
    attrs.className,
    {
      [styles.card]: true
    }
  )

  return (
    <div {...attrs}>
      {
        image
          ? <Link
            href={url}>
            <a
              className={'w-full block cursor-pointer'}
              style={
                {
                  height: breakpoint.mdAndUp ? '22rem' : '12.625rem',
                  overflow: 'hidden',
                  objectFit: 'cover'
                }
              }>
              <Image
                src={image}
                className={'w-full h-full'}
                style={
                  {
                    objectFit: 'cover'
                  }
                } />
            </a>
          </Link>
          : null
      }
      <Card.Body>
        <div
          className={'flex flex-row justify-between items-center mt-4'} >
          <Typography
            className={'text-green-500'}>
            {category || ''}
          </Typography>
          <Typography
            size={'two'}
            className={'text-gray-400'}>
            {date}
          </Typography>
        </div>
        <div
          className={'mt-4'}>
          <Link
            href={url}>
            <a
              className={'w-full block cursor-pointer'}>
              <Typography
                weight={'black'}
                className={'text-black max-w-big mb-2'}
                clamp={2} >
                {title}
              </Typography>
            </a>
          </Link>
          {
            (author || time)
              ? <Typography
                size={'two'}
                className={'mb-6 text-gray-400'} >
                {author ? <>Por {author}</> : null}
                {(author && time) ? <> | </> : null}
                {time ? <>Lectura: {readingTime} minutos</> : null}
              </Typography>
              : null
          }

          <Typography
            size={'two'}
            className={'mb-6 text-gray-400'}
            clamp={2} >
            <RawHTML html={text} />
          </Typography>
        </div>

        <div className={'flex items-center text-green-500'}>
          <Button
            color={'pink'}
            href={url} >
            <Typography >
              Leer más&nbsp;
            </Typography>
            <Icon
              size={20}
              svg={ArrowRight} />
          </Button>
        </div>
      </Card.Body>
    </div>
  )
}

CardBigDefault.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  slug: PropTypes.string,
  date: PropTypes.string,
  author: PropTypes.string,
  time: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  category: PropTypes.string
}

export default CardBigDefault
